// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".loader-image[data-v-17e7cbaa]{width:60px;height:60px;left:50%;top:50%;transform:translate(-50%,-50%);position:absolute;z-index:9999}", ""]);
// Exports
module.exports = exports;
